const getVideoDuration = (file) =>
  new Promise((resolve) => {
    try {
      if (!file?.type?.startsWith('video')) return resolve(0);
      const url = URL.createObjectURL(file);
      const v = document.createElement('video');
      v.preload = 'metadata';
      v.src = url;
      v.onloadedmetadata = () => {
        const d = isFinite(v.duration) ? v.duration : 0;
        URL.revokeObjectURL(url);
        resolve(d);
      };
      v.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(0);
      };
      v.style.position = 'absolute';
      v.style.left = '-9999px';
      v.style.width = '1px';
      v.style.height = '1px';
      document.body.appendChild(v);
    } catch (err) {
      resolve(0);
    }
  });

export default getVideoDuration;
